/** @format */
import { easings } from '@react-spring/web';
import { TFunction } from 'next-i18next';

import {
    DisputeItem,
    DisputeItemType,
    ProductItemWarrantySummary,
} from '@toucan/client/global/transaction';

export const getSummaryItemWarrantyAnimationConfig = (
    shouldAnimate: boolean
) => {
    if (!shouldAnimate) {
        return {};
    }

    const rollInDuration = 500;
    const pulseDuration = 60;
    const pulseDelay = 600;

    return {
        from: {
            maxHeight: '0px',
            opacity: 0,
            transform: 'scale(1)',
        },
        enter: [
            {
                maxHeight: '72px',
                opacity: 1,
                config: {
                    duration: rollInDuration,
                    easing: easings.easeInOutQuad,
                },
            },
            {
                config: { duration: pulseDuration },
                transform: 'scale(1.05)',
                delay: pulseDelay,
            },
            {
                config: { duration: pulseDuration },
                transform: 'scale(1)',
                delay: pulseDelay,
            },
            {
                config: { duration: pulseDuration },
                transform: 'scale(1.05)',
                delay: pulseDelay,
            },
            {
                config: { duration: pulseDuration },
                transform: 'scale(1)',
                delay: pulseDelay,
            },
        ],
        leave: {
            maxHeight: '0px',
            opacity: 0,
            config: {
                easing: easings.easeInOutQuad,
            },
        },
    };
};

export const hasWarrantyContextId = (
    warranty: unknown
): warranty is ProductItemWarrantySummary => {
    return Boolean((warranty as ProductItemWarrantySummary)?.warrantyContextId);
};

export const getWarrantyDisputes = (disputes: DisputeItem[]): DisputeItem[] => {
    return disputes.filter(
        (dispute) => dispute.disputedItemType === DisputeItemType.WARRANTY
    );
};

export function getWarrantySummaryTitle(t: TFunction) {
    return t('Extended Product Protection you’re cancelling');
}
